import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.page.html',
  styleUrls: ['./tabs.page.scss'],
})
export class TabsPage implements OnInit {

  constructor(
    public platformSRV:PlatformService,
    private router: Router,
    public appComponent:AppComponent,
    public dataSRV:DataService
  ) { }

  ngOnInit() {
  }
  paymentsIsActive(){
    return this.router.isActive('payments', false); 
  }
  profileIsActive() {
    return this.router.isActive('account/profile', false); 
  }
  homeIsActive() {
    return this.router.isActive('home', false); 
  }
  vehiclesIsActive() {
    return this.router.isActive('vehicles', false); 
  }
  permitsIsActive() {
    return this.router.isActive('permits', false); 
  }
  appealsIsActive() {
    return this.router.isActive('violations/appeals', false); 
  }
  lockersIsActive() {
    return this.router.isActive('lockers', false); 
  }
  

}
